import SeriesLegend from './series.component';
export default SeriesLegend;
